// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PredictiveLoadingBarTsx from "./PredictiveLoadingBar.tsx";

let make = PredictiveLoadingBarTsx.PredictiveLoadingBar;

function statusFromAsyncResult(asyncResult) {
  if (typeof asyncResult !== "object") {
    if (asyncResult === "NotAsked") {
      return "idle";
    } else {
      return "pending";
    }
  } else if (asyncResult.TAG === "Reloading") {
    return "pending";
  } else if (asyncResult._0.TAG === "Ok") {
    return "idle";
  } else {
    return "failed";
  }
}

export {
  make,
  statusFromAsyncResult,
}
/* make Not a pure module */
